module.exports = __webpack_public_path__ + "img/worksbot_img19112544.7f5419df.jpg";